<template>
  <div class="register">
    <h2>会员注册</h2>
    <div class="form" >
      <input type="text" placeholder="请输入您的手机号" ref="number">
      <div class="getCode">
        <input type="text" placeholder="请点击右侧获取验证码" ref="code"/>
        <p v-if="this.show === '1'" class="send" @click="getCode()">获取验证码</p>
        <p v-else-if="this.show === '2'"><img src="../../../static/images/wait.png" class="wait" height="50px"/></p>
        <p v-else-if="this.show === '3'" class="send" @click="getCode()">648121</p>
      </div>
      <input type="password" placeholder="请输入您的密码" ref="password">
      <input type="password" placeholder="确认密码" ref="repassword">
      <input type="button" value="立即注册" @click="register()">
    </div>
    <div class="toggle">
      <span class="toggle-tip">已有账号 ,</span> 
      <router-link to="/entry/login" tag="span" class="goLogin">
        立即登陆
      </router-link>
    </div>
    <!-- <div class="success" v-if="!this.success">
      <img src="../../../static/images/success.png">
    </div> -->
  </div>
</template>

<script>
export default {
  name: 'register',
  data () {
    return {
      show: '1',
      success: false
    }
  },
  methods: {
    getCode: function () {
      let _This = this
      if (_This.show === '3') {
        return
      }
      _This.show = '2'
      setTimeout(() => {
        _This.show = '3'
      }, 1000);
    },
    register: function () {
      let number = this.$refs.number.value,
          code = this.$refs.code.value,
          password = this.$refs.password.value,
          repassword = this.$refs.repassword.value
      console.log(typeof code)
      if (number && code === '648121' && password && repassword) {
        if(typeof(Storage)!=="undefined")
        {
          localStorage.setItem('user', number);
          localStorage.setItem('password', password);
        }
        alert('注册成功！')
        this.$router.push('/entry/login')
      } else {
        alert('注册失败！请重新注册。')
      }
    }
  }
}
</script>

<style scoped>
.register {
  text-align: center;
  background-color: #fff;
  height: 100%;
}
.register > h2 {
  font-size: 30px;
  color: #fff;
  line-height: 72px;
  background-color: #ff574e;
}
.form {
  display: flex;
  flex-flow: column nowrap;
  padding: 44px 210px 0;
}
.form input{
  padding: 10px;
  border: 1px solid #c0c0c0;
  margin-bottom: 24px;
  font-size: 18px;
}
.form input[type=button]{
  background-color: #f1f1f1;
}
.form input:last-child {
  margin: 34px 0;
}
.getCode {
  display: flex;
}
.send {
  min-width: 100px;
  cursor: pointer;
}
.getCode > p{
  font-size: 20px;
  color: #ff574e;
  line-height: 42px;
  padding-left: 20px;
}
.toggle {
  padding: 0 0 40px;
}
.goLogin {
  font-size: 20px;
  text-decoration: underline;
  cursor: pointer;
}
.goLogin:hover{
  color: #ff574e;
}
.toggle-tip {
  font-size: 20px;
}
.wait {
  animation: waitMove 2s infinite;
}
.success {
  position: fixed;
  left: 50%;
  top: 50%;
  margin-left: -75px;
  margin-top: -75px;
  font-size: 0;
  opacity: 0;
  animation: success 3s;
}

/* 动画部分 */
@keyframes waitMove {
  from {transform: rotate(0deg)}
  to {transform: rotate(360deg)}
}
/* @keyframes success {
  0% {
    opacity: 0;
    margin-top: -75px;
  }
  25% {
    margin-top: -120px;
    opacity: 1;
  }
  50% {
    opacity: 1;
    transform: rotate(0)
  }
  100% {
    opacity: 0;
    transform: rotate(360deg)
  }
}
 */
/* 媒体查询部分 */
@media (max-width: 1199px) {
  .form {
    padding: 24px 110px 0;
  }
  .form input:last-child {
    margin: 14px 0;
  }
}
@media screen and (max-width: 801px){
  .form {
    padding: 24px 10px 0;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/userEntry/register.vue